function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__b",
  width: 512,
  height: 512,
  x: -512,
  y: -512,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__a"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__d",
  width: 512,
  height: 512,
  x: -496,
  y: -500,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__b"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__f",
  width: 512,
  height: 512,
  x: -476,
  y: -511,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__c"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__j",
  width: 512,
  height: 512,
  x: -511.181,
  y: -511.106,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__d"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__n",
  width: 512,
  height: 512,
  x: -501,
  y: -512,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__e"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__q",
  width: 512,
  height: 512,
  x: -511.528,
  y: -480.927,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__f"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "not-found_svg__t",
  width: 512,
  height: 512,
  x: -473,
  y: -498,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__g"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__h",
  x1: "50%",
  y1: "11.746%",
  y2: "70.64%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF2D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFE0A6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__i",
  x1: "62.461%",
  x2: "39.269%",
  y1: "32.027%",
  y2: "59.307%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__l",
  x1: "-16.962%",
  x2: "57.042%",
  y1: "35.04%",
  y2: "87.374%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFEFFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFDBF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__o",
  x1: "-12.048%",
  x2: "55.234%",
  y1: "23.161%",
  y2: "78.446%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFEFFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFDBF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__r",
  x1: "-6.187%",
  x2: "55.659%",
  y1: "15.994%",
  y2: "72.561%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFEFFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFDBF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not-found_svg__u",
  x1: "50%",
  x2: "92.114%",
  y1: "100%",
  y2: "10.06%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#95ABC2",
  stopOpacity: 0.244
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#5C738E"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "not-found_svg__a",
  cx: 58.5,
  cy: 11.5,
  rx: 58.5,
  ry: 11.5
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "not-found_svg__c",
  cx: 74.5,
  cy: 23.5,
  rx: 58.5,
  ry: 11.5
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "not-found_svg__e",
  cx: 94.5,
  cy: 12.5,
  rx: 58.5,
  ry: 11.5
}), /*#__PURE__*/React.createElement("path", {
  id: "not-found_svg__g",
  d: "M.82 71.207l107.352-65.42a4 4 0 015.986 4.285L88.528 125.17c-9.842-14.205-22.473-26.052-37.894-35.54C27.504 75.4.82 71.208.82 71.208z"
}), /*#__PURE__*/React.createElement("path", {
  id: "not-found_svg__p",
  d: "M50.5 91c20.71 0 46.607-.837 46.607-21.548 0-20.71-12.896-38.38-33.607-38.38-20.71 0-63.028 17.67-63.028 38.38C.472 90.163 29.79 91 50.5 91z"
}), /*#__PURE__*/React.createElement("path", {
  id: "not-found_svg__v",
  d: "M6.48 0h7.344v7.325a6.48 6.48 0 01-6.48 6.48H0V6.48A6.48 6.48 0 016.48 0z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "not-found_svg__m",
  cx: 48.5,
  cy: 37.5,
  r: 37.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "not-found_svg__s",
  cx: 76.5,
  cy: 51.5,
  r: 37.5
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFD3F8",
  xlinkHref: "#not-found_svg__a"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFD3F8",
  xlinkHref: "#not-found_svg__c"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFD3F8",
  xlinkHref: "#not-found_svg__e"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "not-found_svg__k",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__g"
}));

var _ref6 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#not-found_svg__h)",
  xlinkHref: "#not-found_svg__g"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#not-found_svg__l)",
  xlinkHref: "#not-found_svg__m"
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#not-found_svg__o)",
  xlinkHref: "#not-found_svg__p"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#not-found_svg__r)",
  xlinkHref: "#not-found_svg__s"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#ADFFFC",
  d: "M120.33 194.06c2.056 4.881 4.996 5.995 7.92 6.882m-64.429 28.819c-4.578-2.284-6.906-1.478-9.062-.521"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M98.94 168.779c3.286-.164 4.56-1.643 5.7-3.162m12.666 55.732c.816.228 1.897.107 2.968-.031"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C4A2FF",
  d: "M110.737 143.94c-1.399 2.978-.691 4.798.115 6.517m23.893 81.373c-1.173-.283-1.563-.088-1.9.13"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFA6EA",
  d: "M90.804 195.6c-4.916 1.97-6.081 4.89-7.019 7.799"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#D6FFA9",
  d: "M142.621 171.644c-2.577 2.2-2.687 3.827-2.662 5.389m-77.402 37.826c2.363.885 3.464.369 4.472-.211"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAFAF",
  d: "M167.03 185.813c-3.51-1.675-5.268-1.031-6.894-.276M89.308 230.16c1.47 1.186 3.52 1.397 5.558 1.55"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(94 170)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 22,
  fill: "#746CA0",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 22,
  x: 24,
  fill: "#746CA0",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#746CA0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M8.5 34.5c2.981-2 5.974-3 8.98-3 3.005 0 6.019 1 9.04 3"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#not-found_svg__u)",
  strokeDasharray: "4 10",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M42.518 216.897c32.996 37.049 61.388 41.654 85.174 13.817 16.066-31.854-1.595-54.38 2.44-71.867 7.72-33.459 44.468-49.938 67.55-34.197 8.712 5.941 10.19 36.349-36.217 25.316-16.348-3.887-31.62-14.116-28.886-43.575 3.937-42.434 56.251-45.66 58.333-47.087",
  opacity: 0.5,
  transform: "rotate(-112 105.197 105.066)"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-75 25.73 25.894)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CED8E5",
  d: "M20.57 21.353c-.312-7.857-1.509-12.827-3.59-14.907-3.12-3.122-8.185-3.118-11.31.007-3.126 3.126-3.13 8.19-.008 11.311 2.08 2.081 7.05 3.277 14.907 3.589zm5.472 4.718c.312 7.858 1.508 12.827 3.589 14.908 3.121 3.121 8.185 3.118 11.31-.008 3.126-3.125 3.13-8.19.009-11.31-2.081-2.082-7.05-3.278-14.908-3.59z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.735 16.06)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "not-found_svg__w",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#not-found_svg__v"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#A8B7C5",
  xlinkHref: "#not-found_svg__v"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDE5F2",
  d: "M2.91.727h2.183v15.985H2.91z",
  mask: "url(#not-found_svg__w)",
  transform: "rotate(-45 4.002 8.72)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDE5F2",
  d: "M1.945.206l1.544-1.543 11.3 11.303-1.543 1.544z",
  mask: "url(#not-found_svg__w)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#8696C5",
  strokeWidth: 0.72,
  d: "M37.982 12.601l5.31-1.264m-7.493-.915l2.043-5.258"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32.742,
  cy: 14.607,
  fill: "#8B9AA8",
  rx: 5.821,
  ry: 5.813
}));

function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 243
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 208)"
  }, _ref2, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__b)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 208)"
  }, _ref3, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__d)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 208)"
  }, _ref4, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__f)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93 72)"
  }, _ref5, _ref6, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__i)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__j)",
    fillOpacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8C4545",
    strokeWidth: 3,
    d: "M45 43c24.886-3.421 43.637 8.202 56.252 34.871M29 54c30.84-2.825 53.84 13.509 69 49M57 31c25.212-5.65 43.963 5.974 56.252 34.871M65.367 20.157c28.908-6.355 47.7 4.84 56.374 33.586M89.626 10.936c17.283-3.58 27.616 3.42 31 21M56.813 92.202c0-1.576.809-35.68-18.813-55.202m39.813 53.202c0-1.576.809-35.68-18.813-55.202m38.994 55.202c0-1.833.989-41.497-22.994-64.202m35.994 48.202c0-1.833.989-41.497-22.994-64.202",
    mask: "url(#not-found_svg__k)",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 133)"
  }, _ref7, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__n)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__m"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 133)"
  }, _ref8, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__q)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__p"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 133)"
  }, _ref9, /*#__PURE__*/React.createElement("use", {
    fill: "url(#not-found_svg__t)",
    fillOpacity: 0.1,
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#not-found_svg__s"
  })), _ref10, _ref11, _ref12, _ref13));
}

export default "data:image/svg+xml;base64,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";
export { SvgNotFound as ReactComponent };